import React from "react";
import {useNavigate} from "react-router-dom";
import {useCartContext} from "../contexts/CartContext";
import ItemImage from "./ItemImage";

const CartDrawer = () => {
    const {cartLines, isDrawerOpen, closeDrawer, updateQuantity, removeFromCart} = useCartContext();
    const navigate = useNavigate();

    const total = cartLines.reduce((sum, line) => sum + line.bruttoPrice * line.quantity, 0);

    const handleCheckout = () => {
        closeDrawer();
        navigate("/cart/checkout");
    };

    const handleViewCart = () => {
        closeDrawer();
        navigate("/cart");
    };

    return (
        <>
            <div
                className={`fixed inset-0 bg-black z-40 transition-opacity duration-300 ${
                    isDrawerOpen ? "bg-opacity-50 pointer-events-auto" : "bg-opacity-0 pointer-events-none"
                }`}
                onClick={closeDrawer}
            ></div>

            <div
                className={`fixed top-0 right-0 h-full w-full sm:w-96 bg-white shadow-lg z-50 flex flex-col transition-transform duration-300 ${
                    isDrawerOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                <div className="flex items-center justify-between p-4 border-b">
                    <h2 className="text-lg font-bold text-gray-800">Warenkorb</h2>
                    <button onClick={closeDrawer} className="text-gray-500 hover:text-gray-700 text-xl leading-none">
                        &#10005;
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-4 space-y-4">
                    {cartLines.length === 0 ? (
                        <p className="text-gray-500">Dein Warenkorb ist leer.</p>
                    ) : (
                        cartLines.map((line) => (
                            <div key={line.itemVariantId} className="flex items-center gap-3">
                                <ItemImage src={line.itemImage} alt={line.itemName} className="w-16 h-16 rounded-md object-cover flex-shrink-0"/>
                                <div className="flex-1 min-w-0">
                                    <h3 className="font-semibold text-gray-800 text-sm truncate">{line.itemName}</h3>
                                    <p className="text-xs text-gray-500">
                                        {line.variantProperties.map((property) => `${property.name}: ${property.value}`).join(" · ")}
                                    </p>
                                    <div className="flex items-center gap-2 mt-1">
                                        <button
                                            onClick={() => updateQuantity(line.itemVariantId, line.quantity - 1)}
                                            className="w-6 h-6 border border-gray-300 rounded hover:bg-gray-100"
                                        >
                                            −
                                        </button>
                                        <span className="text-sm w-4 text-center">{line.quantity}</span>
                                        <button
                                            onClick={() => updateQuantity(line.itemVariantId, line.quantity + 1)}
                                            className="w-6 h-6 border border-gray-300 rounded hover:bg-gray-100"
                                        >
                                            +
                                        </button>
                                        <button
                                            onClick={() => removeFromCart(line.itemVariantId)}
                                            className="text-xs text-red-500 hover:text-red-700 ml-2"
                                        >
                                            Entfernen
                                        </button>
                                    </div>
                                </div>
                                <p className="text-sm font-semibold text-gray-800 whitespace-nowrap">
                                    {(line.bruttoPrice * line.quantity).toFixed(2)} {line.currency.toUpperCase()}
                                </p>
                            </div>
                        ))
                    )}
                </div>

                {cartLines.length > 0 && (
                    <div className="p-4 border-t">
                        <div className="flex justify-between font-bold text-gray-800 mb-4">
                            <span>Zwischensumme</span>
                            <span>{total.toFixed(2)} {cartLines[0].currency.toUpperCase()}</span>
                        </div>
                        <button
                            onClick={handleCheckout}
                            className="w-full bg-pegasusPurple text-white py-2 rounded-lg font-semibold hover:bg-pegasusPurpleHover"
                        >
                            WEITER ZUR KASSE
                        </button>
                        <button
                            onClick={handleViewCart}
                            className="w-full text-pegasusPurple text-sm mt-2 py-2 hover:underline"
                        >
                            Warenkorb ansehen
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default CartDrawer;
